import { SAButton } from '@saux/design-system-react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import success_png from '../../icons/Success.png';
import error_png from '../../icons/Error.png';
import snackbarOpen from '../../store/action-creators/snackbarActionCreators';
import { getAllAdjusters } from '../../store/actions/adjusterActions';
import { bulkAddAdjuster, bulkTransferAdjuster } from '../../store/actions/conversationActions';
import { CONVERSATION_CONTROL_TABS, COPY, COPY_ALL, SEARCH, SNACKBAR, TEXTING_ACCESS, TRANSFER, TRANSFER_ALL } from '../../utils/constants';
import { simpleGTMDataLayer } from '../../utils/utilities';
import APIResponsePage from '../dashboardAPIResponsePage/DashboardAPIResponsePage';
import { AutoCompleteTexting } from './AutoCompleteTexting';
import { updateBatchType, updateFromAdjuster, updateToAdjuster } from '../../store/action-creators/adjusterActionCreator';

const AdjusterComponent = styled.div`
    position:relative;
`;
export default function AdjusterSearch(props: any) {
    const [isFocussed, setFocussed] = useState(false);
    const [isAPISuccess, setAPISuccess] = useState(false);
    const [selectedAdjuster, setSelectedAdjuster] = useState<any>(null);
    const [apiResponse, setAPIResponse] = useState<any>({});
    const [count, setCount] = useState(0);
    const user = useSelector((state: any) => state.user);
    const [adjusters, setAdjusters] = useState<any>([]);
    const loader = useSelector((state: any) => state.loader.dashboardLoader)
    const dispatch = useDispatch();
    const selectedButton = props.selectedButton;
    const isInitialAllConversations = (props.selectedType === CONVERSATION_CONTROL_TABS.ALLCONVERSATIONS && !selectedButton)

    useEffect(() => {
        setCount(props.count);
    }, [])

    const handleAction = () => {
        props?.setConversationsEmpty()
        dispatch(updateToAdjuster(selectedAdjuster));
        dispatch(updateBatchType((selectedButton === TRANSFER || selectedButton === TRANSFER_ALL) ? TRANSFER : COPY))
        if (props.selectedType === CONVERSATION_CONTROL_TABS.ALLCONVERSATIONS) {
            dispatch(updateFromAdjuster(props.fromAdjuster));
        }
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Confirm-${selectedButton}-Click`,
            event_action: 'Button Click',
            event_category: window.location.pathname,
            event_label: `Confirm ${selectedButton} the conversations`,
            event_value: `${user.fullName} was requesting for ${selectedButton} ${selectedAdjuster.adjusterName} conversations. `
        });
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Confirm-${selectedButton}-Click-Snowplow`,
            event_action: 'Button Click',
            event_category: window.location.pathname + "/Snowplow",
            event_label: `Confirm ${selectedButton} the conversations`,
            event_value: `${user.fullName} was requesting for ${selectedButton} ${selectedAdjuster.adjusterName} conversations. `
        });

        //Conversations count Snowplow tag
        let actionType = (selectedButton === TRANSFER || selectedButton === TRANSFER_ALL) ? TRANSFER : COPY;
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Conversations-Count`,
            event_action: 'Button Click',
            event_category: window.location.pathname,
            event_label: `Select ${props.count} conversations`,
            event_value: `${user.fullName} selected ${props.count} conversations to ${actionType}.`
          });
          simpleGTMDataLayer({
            csrId: user.userName,
            event: `Conversations-Count-Snowplow`,
            event_action: 'Button Click',
            event_category: window.location.pathname + "/Snowplow",
            event_label: `Selected ${props.count} conversations`,
            event_value: `${user.fullName} selected ${props.count} conversations to ${actionType}.`
          });
        //API call
        const conversations = Object.values(props.selectedConversations)
            .map((con: any) => {
                return {
                    participantId: con.participantId,
                    conversationId: con.conversationId
                }
            });
        const currentAdjuster = props.selectedType === CONVERSATION_CONTROL_TABS.ALLCONVERSATIONS ? props.fromAdjuster.adjusterEmailId:user.email;
        const batchUpdateConversationInput: any = {
            conversationParticipantIds: (selectedButton === TRANSFER_ALL || props.selectedButton === COPY_ALL) ? [] : conversations,
            currentAdjusterId: currentAdjuster,
            newAdjusterId: selectedAdjuster.adjusterEmailId,
            newAdjusterName: selectedAdjuster.adjusterName
        }
        if (props.selectedButton === TRANSFER_ALL || props.selectedButton === COPY_ALL) {
            batchUpdateConversationInput["actionFlag"] = "all";
        }
        if (props.selectedButton === TRANSFER || props.selectedButton === TRANSFER_ALL) {
            dispatch(bulkTransferAdjuster(batchUpdateConversationInput, (res: any) => {
                setAPIResponse(res);
                setAPISuccess(true);
            }, (error: any) => {
                setAdjusters([]);
            }))
        }
        else {
            if (props.selectedButton === COPY_ALL && props.selectedType === CONVERSATION_CONTROL_TABS.ALLCONVERSATIONS) {
                batchUpdateConversationInput["actionFlag"] = "all-" + user.email;
                batchUpdateConversationInput["currentAdjusterId"] = props.fromAdjuster.adjusterEmailId;
            }
            dispatch(bulkAddAdjuster(batchUpdateConversationInput, (res: any) => {
                setAPIResponse(res);
                setAPISuccess(true);
            }, (error: any) => {
                setAdjusters([])
            }))
        }
    }

    const handleSearchConversations = () => {
        props.setFilter(false);
        props.updateAdjuster(selectedAdjuster);
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Search-Adjuster-Conversations-Click`,
            event_action: 'Button Click',
            event_category: window.location.pathname,
            event_label: `Tab click in conversation control page`,
            event_value: `${user.fullName} was requesting for ${selectedAdjuster.adjusterName} conversations for copying to other adjuster. `
        });

        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Search-Adjuster-Conversations-Click-Snowplow`,
            event_action: 'Button Click',
            event_category: window.location.pathname + "/Snowplow",
            event_label: `Tab click in conversation control page`,
            event_value: `${user.fullName} was requesting for ${selectedAdjuster.adjusterName} conversations for copying to other adjsuter. `
        });
    }

    const getSuccessText = () => {
        return `You have successfully started the ${selectedButton} process for ${user.email === props.fromAdjuster.adjusterEmailId ? `[${count}] conversations` : `[${count}] conversations from [${props.fromAdjuster.adjusterName}]`} to [${selectedAdjuster.adjusterName}]`;
    }

    const getSubText = () => {
        let type = selectedButton === TRANSFER ? "Transferred" : "copied"
        return `[${apiResponse.failed}] Conversations were not ${type} from [${props.fromAdjuster.adjusterName}] to [${selectedAdjuster.adjusterName}] because they are already part of the conversation`;
    }

    const handleSelect = (index: any) => {
        setFocussed(false);
        if(props.fromAdjuster !==undefined){
            let filterAdjuster = adjusters.filter((adj:any)=>{
                return adj.adjusterEmailId !== props.fromAdjuster.adjusterEmailId
            });
            setSelectedAdjuster(filterAdjuster[index]);
        }
        else{
            let adjuster = adjusters.filter((adj:any)=>{
                return adj.adjusterEmailId !== user.email
            });
            setSelectedAdjuster(adjuster[index]);
        }
        
    }

    const handleChange = (value: any) => {
        getAllAdjusters({ query: value, adjusterRoles:[TEXTING_ACCESS]}).then((res: any) => {
            let adjustersList = res.data && res.data && res.data.searchAdjuster;
            let updatedList = adjustersList.map((user: any) => {
                    return {
                        adjusterName: user.adjuster_name?.replace(/- /g, ""),
                        adjusterEmailId: user.contact_email?.toLowerCase()
                    }
                });
               
                
            setAdjusters(updatedList);
        }).catch(error => {
            console.log(error);
            dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
        })
    }
    const getAutoCompleteLabel = () => {
        const label = isInitialAllConversations
            ? "Select an Adjuster" : "Select an Adjuster to " + selectedButton;
        return label;
    }

    const getAdjusterNames = () => {
        return adjusters
            .filter((adjuster: any) => {
                if (isInitialAllConversations || props.selectedType === CONVERSATION_CONTROL_TABS.MYCONVERSATIONS) {
                    return adjuster?.adjusterEmailId !== user.email;
                } else {
                    return props.fromAdjuster?.adjusterEmailId !== adjuster?.adjusterEmailId;
                }
            })
            .map((adjuster: any) => {
                return adjuster.adjusterName;
            })
    }

    return (
        loader.isLoading ?
            <div className="loader" />
            :
            <AdjusterComponent data-testid="adjuster-search">
                {!isAPISuccess ? <div>
                    <div style={{ fontWeight: "bold", marginBottom: 20 }}>{isInitialAllConversations ? "Search for Adjuster Conversations" : `[${props.count}] Conversation(s) of ${props.fromAdjuster.adjusterName} selected for ${selectedButton}.`}</div>
                    <AutoCompleteTexting
                        id="adjusters"
                        label={getAutoCompleteLabel()}
                        fullWidth={true}
                        options={getAdjusterNames()}
                        onFocus={(e: any) => setFocussed(true)}
                        onBlur={(e: any) => setFocussed(false)}
                        onChange={(e: any) => handleChange(e.currentTarget.value)}
                        onSelect={(index: number) => handleSelect(index)}
                    />
                    <div style={{ display: "flex", float: "right", marginTop: isFocussed ? 250 : 25 }}>
                        {isInitialAllConversations ?
                            <>
                                <SAButton style={{ color: "white", backgroundColor: "#65A100", fontSize: 16 }} label={SEARCH} variant="small" disabled={selectedAdjuster ? false : true} onClick={handleSearchConversations} />
                            </> :
                            <>
                                <SAButton style={{ color: "black" }} label="Cancel" variant="link-small" onClick={props.handleCancel} />
                                <SAButton style={{ color: "white", backgroundColor: "#65A100", fontSize: 16 }} label={selectedButton} variant="small" disabled={selectedAdjuster ? false : true} onClick={handleAction} />
                            </>
                        }
                    </div>
                </div> :
                    <APIResponsePage
                        text={getSuccessText()}
                        count={count}
                        selectedType={props.selectedType}
                        handleViewConversations={props.handleViewConversations}
                        handleNewSearch={props.handleNewSearch}
                        selectedAction ={props.selectedButton}
                    />}
            </AdjusterComponent>
    )
}
